import Cheerio from "cheerio";
import dayjs from 'dayjs';
import _ from 'underscore';
_.templateSettings.interpolate = /\{\{(.+?)\}\}/g;

import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime)

let moment = dayjs;


export function getValues(params) {
    let results = [];
    const data = Object.assign({}, params);
    const items = data.items;
    for (var i = 0; i < items.length; i++) {
        const item = items[i];
        // if(item.display == 'properties') {
        const data = item.data;
        for (var j = 0; j < data.length; j++) {
            //try {
            const dataRow = data[j];
            const source = typeof dataRow.template != "undefined" && dataRow.template ? dataRow.template : '{{model}}';
            // console.log("source", source);
            let d = getValue(data[j]);
            // console.log("getValue", d);
            if (d) {
                d['$item'] = { ...item };
                d['$root'] = params;
                d['$data'] = {};
                try {
                    d['$data'] = item.rows.length ? item.rows[0] : {};
                } catch(error) {

                }
                d.model = compile(source, d);
                results.push(d);
            } else {
                //console.log("empty", data[j])
            }
        // } catch(error) {
        //     console.log("error", error);
        // }
        }
        // } else if(item.display == 'signatories') {

        // }

    }
    return results;
}

function getTemplate() {

}

function getValue(obj) {
    try {

        const id = obj.id;
        const model = typeof obj.model != "undefined" ? obj.model : null;
        const template = typeof obj.template != "undefined" ? obj.template : null;
        if (model == null && template == null) {
            return null;
        }
        return { id: id, model: model, template: template };
    } catch (error) {

    }
    return null;
}


export function insertValues(html, values) {
    // let h = injectStyles(html);
    const $ = Cheerio.load(html);
    for (let i = 0; i < values.length; i++) {
        const item = values[i];
        // $("[data-id=" + item.id + "]").html(item.value);
        $("[data-id=" + item.id + "]").replaceWith(item.model);
    }
    return $("body").html();
}

export function interpolate(html, schema) {
    const values = getValues(schema);
    return insertValues(html, values);
}

export function compile(html, schema) {
    // console.log("schema", schema);
    let compiled = _.template(html);
    schema.moment = moment;
    return compiled(schema);
}

export function injectStyles(content) {
    
    let t = '<html><head><link href="https://cdn.quilljs.com/1.3.6/quill.snow.css" rel="stylesheet"><style>html, body {height: 100%;margin: 0;} .ql-container.ql-snow {border: 0px solid #ccc;} .ql-container {height: auto;} .ql-editor { overflow-y: initial; white-space: initial;} .ql-container table {border-collapse: collapse;} .ql-editor table td { border: 1px solid #ccc } .ql-editor table td { border: 1px solid #ccc } .ql-container table.border td {border: 1px solid #ccc; padding: 10px; } table.noborder td { border: 0px dashed #ccc !important; } .ql-divider:after {  content: "-";}.ql-editor hr {    border: none;    color: #111;    letter-spacing: 1em;    text-align: center; page-break-before: always;}@media print {  hr { page-break-before: always; visibility: hidden; }}.ql-editor {  counter-reset: number;}.ql-editor hr {  counter-increment: number;}.ql-editor hr:before {  content: \'..... PAGE BREAK \' counter(number) \' .....\';}</style></head><body><div class="quill-editor editor-example bubble editor-element"><div class="ql-container ql-snow"><div class="ql-editor preview">body_content</div></div></div></body></html>';
    return t.replace("body_content", content);
    // console.log("styles", styles);
}